// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2xx6I","active":"downloadDropdown_active__2hWbJ"};